import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../service/auth.service';


@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})


export class ProfileComponent implements OnInit {
  profileForm!: FormGroup;
  userId!: string;
  isLoading = false;
  isEditMode = false;
  user:any;
  profileUpdateError = '';

  constructor(private fb: FormBuilder, private authService: AuthService) {}

  ngOnInit(): void {
    //const email = localStorage.getItem('username');
    this.user = JSON.parse(sessionStorage.getItem('current-user-context'));
    console.log("Email", this.user.username);

    this.profileForm = this.fb.group({
      firstName: [{ value: '', disabled: true }, Validators.required],
      lastName: [{ value: '', disabled: true }, Validators.required],
      phoneNumber: [
        { value: '', disabled: true },
        [
          Validators.required,
          Validators.pattern(/^[6-9]\d{9}$/) // ✅ Indian mobile numbers starting with 6-9
        ]
      ]
    });

    this.loadUser();
  }

  loadUser(): void {
     if (this.user.username) {
      // Replace this with your actual AuthService call
      this.authService.getUserDetails(this.user.username).subscribe({
        next: (user: any) => {
        this.user = user;

        this.profileForm.patchValue({
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          phoneNumber: this.user.phoneNumber
        });
       },
          error: (err) => {
            console.error('Failed to fetch user details', err);
          }
      });
    }

    this.profileForm.disable(); // just to be explicit
  }

  toggleEdit(): void {
    this.isEditMode = !this.isEditMode;
    this.clearProfileUpdateError();

    if (this.isEditMode) {
      this.profileForm.enable();
    } else {
      this.profileForm.reset(this.user);  // restore original values
      this.profileForm.disable();
    }
  }

  updateProfile(): void {
    this.clearProfileUpdateError();
    if (this.profileForm.invalid) return;
    this.isLoading = true;
    this.authService.updateUserDetails(this.profileForm.value, this.user.id).subscribe({
      next: () => {
        this.isEditMode = false;
        this.isLoading = false;
        this.profileForm.disable();
      },
      error: (err) => {
        console.error('Failed to update profile', err);
        const duplicatePhoneError = err?.error?.errors?.find(error => error?.code === 1109);
        this.profileUpdateError = duplicatePhoneError
          ? 'Phone number is linked to a different email address.'
          : 'Unable to update profile. Please try again.';
        this.isLoading = false;
      }
    });
  }

  clearProfileUpdateError(): void {
    this.profileUpdateError = '';
  }
}
